import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Props = { text: string; tooltipId: string };

// At 14px font / line-height 1.4 in the ~250px-wide column, roughly
// 30 characters fit per line; 2 lines = ~60 chars. 80 keeps us safely
// on the "definitely overflowing" side so we don't show a tooltip on
// notes that obviously fit.
const TRUNCATION_THRESHOLD = 80;

export const TruncatedNotesCell = ({ text, tooltipId }: Props) => {
  const cell = (
    <div className="line-clamp-2 max-w-[250px] cursor-default">{text}</div>
  );

  if (text.length <= TRUNCATION_THRESHOLD) {
    return cell;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{cell}</TooltipTrigger>
        <TooltipContent id={tooltipId}>
          <p className="max-w-xs">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
